import { render } from "./AddServerModal.vue?vue&type=template&id=1e228924&scoped=true"
import script from "./AddServerModal.vue?vue&type=script&lang=js"
export * from "./AddServerModal.vue?vue&type=script&lang=js"

import "./AddServerModal.vue?vue&type=style&index=0&id=1e228924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e228924"]])

export default __exports__